import { render, staticRenderFns } from "./SectionLayout.vue?vue&type=template&id=5fdaa197"
import script from "./SectionLayout.vue?vue&type=script&lang=ts"
export * from "./SectionLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports